import { Row } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export const EnterTooltip = () => {
  return (
    <Row className="align-center text-sm title">
      <InfoCircleOutlined className="mr-2" />
      <span>Press “Enter” if you change values</span>
    </Row>
  );
};
